import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function NewVersionDialog() {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRefresh = () => {
    window.location.href = `${window.location.pathname}?v=${Date.now()}`;
  };

  React.useEffect(() => {
    window.addEventListener('message', (event) => {
      const { key, value } = event.data;
      if (key === 'new_version_available' && value) {
        handleOpen();
      }
    });
  }, []);

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>NEW VERSION AVAILABLE</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          Update to see newer version
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleRefresh}>Update</Button>
      </DialogActions>
    </Dialog>
  );
}
